
import { Button } from '@mui/material'
import { styled } from '@mui/material/styles';


export const ButtonBio = styled(Button)({
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: 16,
    padding: '6px 12px',
    border: '1px solid',
    lineHeight: 1.5,
    backgroundColor: '#0CB967',
    borderColor: '#0CB967',
    fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
        backgroundColor: '#19cd79',
        borderColor: '#19cd79',
        boxShadow: 'none',
    },
    '&:active': {
        boxShadow: 'none',
        backgroundColor: '#19cd79',
        borderColor: '#19cd79',
    },
    '&:focus': {
        boxShadow: '0 0 0 0.2rem rgba(12, 185, 103, .5)',
    },
});
